module.exports = __webpack_public_path__ + "img/prize-04.a841b8c6.png";